module.exports = __webpack_public_path__ + "static/media/whitebottledgoosenew@4x.e717f5d1.png";